module.exports = __webpack_public_path__ + "0a2a3b8ecafaab663ffbea299f886d2d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/ocean.png
// module id = 3157
// module chunks = 0